import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "relative w-full max-w-xl max-h-full z-50" }
const _hoisted_2 = { class: "relative bg-white rounded-lg shadow" }
const _hoisted_3 = { class: "py-3 flex flex-wrap justify-center gap-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DbButton = _resolveComponent("DbButton")!

  return (_openBlock(), _createElementBlock("div", {
    id: "app-modal",
    class: _normalizeClass([_ctx.visible ? 'flex' : 'hidden', "fixed top-0 left-0 right-0 bottom-0 px-5 flex items-center justify-center z-50"]),
    tabindex: "-1"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _renderSlot(_ctx.$slots, "default"),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_DbButton, {
            onOnClick: _ctx.close,
            class: "hydrated button-gap",
            variant: 
              _ctx.modalType === 'submitCancel' ? 'secondary-solid' : 'primary'
            
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t(`${_ctx.cancelText}`)), 1)
            ]),
            _: 1
          }, 8, ["onOnClick", "variant"]),
          (_ctx.modalType === 'submitCancel')
            ? (_openBlock(), _createBlock(_component_DbButton, {
                key: 0,
                onOnClick: _ctx.submit,
                class: "hydrated px-4"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t(`${_ctx.submitText}`)), 1)
                ]),
                _: 1
              }, 8, ["onOnClick"]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", {
      "modal-backdrop": "",
      class: _normalizeClass([_ctx.visible ? 'flex' : 'hidden', "bg-gray-900 bg-opacity-50 fixed inset-0 z-40"])
    }, null, 2)
  ], 2))
}